import { IComponentOptions } from "angular";
import { ContractInstanceDetailController } from "./controller";

export const vsName = "contractInstanceDetailComponent";

export const contractInstanceDetailComponentOptions: IComponentOptions = {
  controller: ContractInstanceDetailController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contractInstance: "<",
    model: "<",
  },
};
